export const getViewMposCommerces = state => {
  return state.viewMposCommerces
}